module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/relation_link_pregnant_right-975f8ba96dfe526c6581e7c989cfe5f2.png";